import { Component, Input, EventEmitter, Output, OnChanges, SimpleChanges } from "@angular/core"
import { FormGroup } from "@angular/forms"
import moment from 'moment'
import sweetAlert from '../../../bmAlert'
import { IKeyword } from "graphql/queries/keyword.queries"

@Component({
  selector: 'multipass-deadline',
  template: `
  <button class="btn-blank" (click)="calendarVisible = !calendarVisible" *ngIf="!form.value.deadline">
    <div class="editable-field empty">
      <i class="editable-field-icon fas fa-calendar-alt tiny-right-buffer text-gray" [class.full]="calendarVisible"></i>
      <span class="text-gray">Flexible timing</span>
    </div>
  </button>
  <span
    *ngIf="form.value.deadline"
    class="editable-field cursor-pointer"
    [ngClass]="{
      'hover': calendarVisible,
      'full': form.value.deadline,
      'empty': !form.value.deadline
    }"
    (click)="calendarVisible = !calendarVisible">
    <i class="far fa-calendar-alt editable-field-icon text-info tiny-right-buffer"></i>
    <span class="text-info">Due {{ deadlineFormattedInTimezone }}</span>
    <span
      class="editable-field-remove tiny-left-buffer"
      (click)="$event.stopPropagation(); onRemoveDeadline()"></span>
  </span>

  <datetime-picker
    *ngIf="calendarVisible"
    [minDate]="minDeadlineDate"
    [maxDate]="maxDeadlineDate"
    [datetime]="form.value.deadline || suggestedDeadline()"
    [timeZone]="form.value.timeZone"
    (choose)="onChooseDeadlineFromPicker($event)"
    (remove)="onRemoveDeadline()"
    (cancel)="closeDialog()"
    (outsideClick)="closeDialog()"
    ></datetime-picker>
  `
})
export class MultipassDeadlineComponent {
  @Input() form: FormGroup;
  @Input() keyword: IKeyword;
  // @Input() calendarVisible: boolean;
  @Input() minDeadlineDate: Function;
  @Input() maxDeadlineDate: Function;
  @Output() closeDeadlineDialog = new EventEmitter();

  calendarVisible: boolean = false;
  deadlineFormattedInTimezone: string;
  shortTimezoneFormat: string;

  ngOnInit(): void {
    this.form.valueChanges.subscribe(() => {
      this.setDeadline()
    })
  }

  ngOnChanges(): void {
    this.setDeadline()
  }

  onShowDeadlinePicker(): void {
    this.calendarVisible = true
  }

  onChooseDeadlineFromPicker(updates: { date: Date, timeZone: string }): void {
    this.form.patchValue({ deadline: updates.date, timeZone: updates.timeZone })
    this.setDeadline()
    this.closeDialog()
  }

  onRemoveDeadline(): void {
    const remove = () => {
      this.form.patchValue({ deadline: null })
      this.closeDialog()
    }

    if (this.keyword && this.keyword.writer && this.keyword.kind === 'deadline') {
      const writerName = this.keyword.writer.displayName
      sweetAlert.confirm({
        title: 'Remove Deadline?',
        text: `${writerName} has already claimed this request.`
      }).then(confirm => { if (confirm) remove() })
    } else if (this.keyword && this.keyword.writer && this.keyword.kind === 'assigned') {
      sweetAlert.confirm({
        title: 'Remove Deadline?',
        text: 'If you want to assign this keyword to a writer, it needs to have a deadline.'
      }).then(confirm => { if (confirm) remove() })
    } else {
      remove()
    }
  }

  suggestedDeadline(): Date {
    return moment().add(7, 'd').toDate()
  }

  // z: either MST, +11, +0530 depending on what's available
  getShortTimezoneFormat(timeZoneId: string): string {
    return timeZoneId ? moment.tz(timeZoneId).format('z') : ''
  }

  getDeadlineFormattedInTimezone(): string {
    return moment.tz(this.form.value.deadline, this.form.value.timeZone).format('ddd. MMM. D, [at] h a z')
  }

  closeDialog(): void {
    this.calendarVisible = false
    this.closeDeadlineDialog.emit()
  }

  setDeadline(): void {
    this.deadlineFormattedInTimezone = this.getDeadlineFormattedInTimezone()
    this.shortTimezoneFormat = this.getShortTimezoneFormat(this.form.value.timeZone)
  }

}
